import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Typo, Nav } from 'tmt-ui-kit';
import PlaceholderSection from '~/components/Section/PlaceholderSection';

import { actions as filterActions } from '~/redux/reducers/filter';
import { isAustralianSite } from '~/utils/region-site-config';

const TopicActivityContainer = styled.div`
  display: flex;
  >div {
    margin-left: 12px;
    display: flex;
    align-items: center;
  }
  @media only screen and (max-width: 600px){
    display: block;
    >h2 {
      margin-bottom: 0px;
    }
    >div {
      margin-left: 0px;
      margin-bottom: 12px;
    }
  }
`;

const enhance = connect(
  state => ({
    activities: state.filter.activities,
  }),
  {
    ...filterActions,
  }
);

class TopicFilterMenu extends Component {
  static propTypes = {
    url: PropTypes.object,
    topic: PropTypes.object,
    sliderRender: PropTypes.func,
    reloadFilterTrips: PropTypes.func,
    logFilterActivity: PropTypes.func,
    omitTitle: PropTypes.bool,
    filterInfo: PropTypes.object,
    activities: PropTypes.array
  };

  constructor(props) {
    super(props);
    const { filterInfo, activities } = this.props;
    const { query, pathname } = this.props.url;
    const activity = (query.activity || filterInfo.topicActivity || '');
    this.state = {
      activity: pathname === '/city' ? this.getActivity(activities, activity) : activity,
      loadingFilterTrip: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { contains } = this.props.topic;
    if (contains === 'filterTrips' && !this.props.omitTitle) {
      const { activities } = this.props;
      const { activity, city } = this.props.url.query;
      if (city && (activity !== nextProps.url.query.activity || city !== nextProps.url.query.city)) {
        this.onChangeFilter(this.getActivity(activities, nextProps.url.query.activity));
      }
    }
  }

  getActivity = (activities = [], activity) => {
    const isActivity = activities.find(c => c.value === activity);
    const defaultActivity = activities.length > 0 && activities[0].value;
    return isActivity ? activity : defaultActivity;
  }

  onChangeFilter = async (value) => {
    const activity = value !== '' ? value : '';
    this.setState({
      activity,
      loadingFilterTrip: true,
    });
    const { city } = this.props.url.query;
    this.props.logFilterActivity('Topic Filter Menu', city || '', activity);
    await this.props.reloadFilterTrips(activity);
    this.setState({
      loadingFilterTrip: false,
    });
  }

  render() {
    const { topic, omitTitle, activities } = this.props;
    const onlyPopularActivities = isAustralianSite();

    return (
      <div ref={(c) => { this.root = c; }} key={topic._id}>
        <section id={topic.slug || undefined} style={{ position: 'relative', top: '-70px' }} />
        {!omitTitle && (
          <TopicActivityContainer>
            <Typo.HeaderTwo>
              {onlyPopularActivities ? 'Popular Activities' : 'Search by Activity'}
            </Typo.HeaderTwo>
            {!onlyPopularActivities && (
              <div>
                <Nav.Dropdown
                  selected={this.state.activity}
                  options={activities}
                  handleOnChange={(e) => this.onChangeFilter(e.target.value)}
                  fontSizeLabel={20}
                  fontWeightLabel={500}
                  iconWeight={600}
                  colorBlueLabel
                />
              </div>
            )}
          </TopicActivityContainer>
        )}
        {topic.contains === 'filterTrips' && !this.state.loadingFilterTrip
          ? this.props.sliderRender()
          : <PlaceholderSection showHeader={false} />
        }
      </div>
    );
  }
}

export default enhance(TopicFilterMenu);
